@if (reportLoadFailed()) {
<div class="report-load-error" role="alert">
  <span>
    The report could not be loaded. Check your connection and select Retry. If
    this keeps happening, refresh the page.
  </span>
  <button type="button" class="k-button" (click)="retryReportLoad()">
    Retry
  </button>
</div>
}

<div id="embedContainer"></div>

<kendo-dialog
  modal
  fade
  [hidden]="!refreshDialogOpened()"
  (close)="closeRefreshDialog()"
  title="Your Session has expired"
  [width]="650"
>
  <span>Please Refresh to continue interacting with your Report</span>

  <kendo-dialog-actions layout="end">
    <button class="k-button" (click)="closeRefreshDialog()">Refresh</button>
  </kendo-dialog-actions>
</kendo-dialog>
